import {Add, Delete} from "@mui/icons-material";
import {IconButton, Paper, Stack, TextField, Typography} from "@mui/material";
import {useState} from "react";
import {translate, truncateSx} from "@util";

type MetadataInputProps = {
  value: {[field: string]: string} | undefined;
  label?: string;
  onChange: (value: {[field: string]: string}) => void;
  readOnly?: boolean;
};

const MetadataInput = ({
  label,
  value = {},
  onChange,
  readOnly,
}: MetadataInputProps) => {
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");
  const [errorKey, setErrorKey] = useState(false);

  const handleAdd = () => {
    if (!newKey) {
      setErrorKey(true);
      return;
    }
    setErrorKey(false);
    onChange({...value, [newKey]: newValue});
    setNewKey("");
    setNewValue("");
  };

  const handleDelete = (key: string) => {
    const newVal = {...value};
    delete newVal[key];
    onChange(newVal);
  };

  const handleKeyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewKey(event.target.value);
    if (event.target.value) setErrorKey(false);
  };

  return (
    <Stack>
      <Typography variant="body1">
        {label ? translate(label) : "Metadata"}
      </Typography>
      <Paper sx={{p: 2, mt: 1}}>
        {!readOnly && (
          <Stack direction="row" gap={2} alignItems={"center"} pb={1}>
            <TextField
              label={translate("common.label.tag")}
              value={newKey}
              onChange={handleKeyChange}
              size="small"
              error={errorKey}
              sx={{flex: 1}}
              variant="standard"
            />
            <TextField
              label={translate("common.label.value")}
              value={newValue}
              onChange={e => setNewValue(e.target.value)}
              size="small"
              variant="standard"
              sx={{flex: 1}}
            />
            <IconButton size="small" onClick={handleAdd}>
              <Add fontSize="small" />
            </IconButton>
          </Stack>
        )}
        <Stack gap={1}>
          {Object.entries(value).map(([key, val]) => (
            <Stack
              key={key}
              height={40}
              direction="row"
              gap={1}
              alignItems="center"
              sx={{}}>
              <Typography sx={{flex: 1, ...truncateSx}}>{key}</Typography>
              <Typography sx={{flex: 1, ...truncateSx}}>{val}</Typography>
              {!readOnly && (
                <IconButton size="small" onClick={() => handleDelete(key)}>
                  <Delete fontSize="small" />
                </IconButton>
              )}
            </Stack>
          ))}
        </Stack>
      </Paper>
    </Stack>
  );
};

export {MetadataInput};
